import type { IFeatureMap } from '../../features';
import {
  affinity,
  autoSend,
  conversation,
  drip,
  emailList,
  emailListFacebook,
  facebook,
  googleAdsSmart,
  invites,
  landingPage,
  mailrailAutoSend,
  mailrailDrip,
  mailrailSingleSend,
  mobileGeoFenceRetargeting,
  mobileGeoFencing,
  omni,
  retargeting,
  search,
  seedSegment,
  singleSend,
  smartSend,
  trackedLink,
} from '../../types/campaigns';

export const Finch: IFeatureMap = {
  data: {
    includedKnownPeople: Infinity,
    includedAnonymousPeople: Infinity,
    trackedActivities: Infinity,
    emailsSent: Infinity,
    standardAudienceData: true,
    audienceSegmentation: true,
    dataImporter: true,
    customDataFields: 0,
    conversionPixels: Infinity,
    implementationsPageVisible: true,
    zapier: Infinity,
    directIntegrations: 0,
    iMISDirectIntegration: false,
    blackbaudDirectIntegration: false,
  },
  ads: {
    [retargeting]: true,
    [mobileGeoFencing]: Infinity,
    [mobileGeoFenceRetargeting]: Infinity,
    [facebook]: true,
    [emailListFacebook]: true,
    [emailList]: 0,
    [search]: false,
    [seedSegment]: false,
    [affinity]: false,
    [googleAdsSmart]: false,
    [omni]: true,
  },
  email: {
    [singleSend]: true,
    [smartSend]: true,
    [autoSend]: true,
    [drip]: false,
    [mailrailSingleSend]: true,
    [mailrailAutoSend]: true,
    [mailrailDrip]: false,
    domainsAuthenticated: Infinity,
  },
  conversations: {
    [conversation]: true,
  },
  creatives: {
    adBannerCreator: 10,
  },
  invites: {
    [invites]: false,
    partnerManager: false,
    partnersPerProject: 0,
    partnerMarketingCollateralBuilder: false,
    partnerDashboards: 0,
  },
  monetization: {
    sponsoredRetargetingCampaigns: false,
    liveSponsorReports: false,
  },
  other: {
    // TODO: set to false when Feathr Lite is released
    flights: true,
    forms: false,
    [trackedLink]: true,
    [landingPage]: true,
    dedicatedIPs: Infinity,
    users: 0,
    childAccountsWithSwitcher: 0,
    childAccountSharingWithPermissionManagement: 0,
    customUserRolesAndPermissionsManagement: false,
  },
  trainingAndSupport: {
    liveChatSupport: true,
    dedicatedCSM: true,
    accessToHelpDeskFeathrAcademyAndFeathrLiveWebinars: true,
    dedicatedStrategicAdvisorHours: 0,
    livePhoneSupport: false,
    dataIntegrationServicesActiveWithLicense: false,
    proResourcesPageVisible: false,
  },
};
